// 各社ポータル: 全社共通＋自社向けの資料一覧。
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { apiGet } from "../lib/api";
import type { Material } from "../types";

export function PortalList() {
  const { companyId } = useParams();
  const [materials, setMaterials] = useState<Material[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!companyId) return;
    apiGet<{ materials: Material[] }>(`/api/portal/materials?companyId=${encodeURIComponent(companyId)}`)
      .then((r) => setMaterials(r.materials))
      .finally(() => setLoading(false));
  }, [companyId]);

  if (loading) return <div className="card">読み込み中…</div>;

  return (
    <div className="card">
      <div className="portal-hd" style={{ marginBottom: 16 }}>
        <div>
          <div className="ph-name">お知らせ一覧</div>
          <div className="ph-sub">共通＋自社の資料 {materials.length}件</div>
        </div>
        <div className="ph-ic">💊</div>
      </div>
      {!materials.length && <div className="empty">まだ配信された資料はありません。</div>}
      {materials.map((m) => {
        const own = m.scope === "targeted" && (m.companyIds || []).includes(companyId || "");
        return (
          <Link key={m.id} to={`m/${m.id}`} className="hist-item" style={{ textDecoration: "none", color: "inherit" }}>
            <span className="h-date">{m.date}</span>
            <span className={`chip u-${m.urgency}`} style={{ flex: "none" }}>
              {m.urgency}
            </span>
            <span className="h-title">{m.title}</span>
            <span className={`chip ${own ? "own" : "common"}`} style={{ flex: "none" }}>
              {own ? "自社" : "共通"}
            </span>
            <span className="chip cat" style={{ flex: "none" }}>
              {m.category}
            </span>
          </Link>
        );
      })}
    </div>
  );
}
